import config from "@/config";

export default {
    getUrl(image, size) {
        return config.asset.base + image.container + "/" + image.entity + "/" + size + "-" + image.version + ".jpg";
    }
}